import store from "@/store";
import { allStrings } from "./langs";

let storeInstance = store;
let fallback = "en";

function flatT(key) {
  return allStrings[storeInstance.state.i18n.lang][key];
}
function replaceArticles(str) {
  let keys, propperKey, propperKeyNoG, g, w;
  if (!str || str.indexOf("$") < 0 || str.indexOf("[") === 0) return str;
  else keys = str.match(/\$[a-zA-Z_]*/g);
  // g = store.getState().session.gender
  // if(g==='U') g = 'M'
  g = "M"; //Remember this is diferents that GENDER_ENUM.MALE. This is in order to find the key in lang
  // w = store.getState().session['for-who']
  w = "self";
  return keys.reduce((result, key) => {
    propperKey = w === "self" ? key + "_self" : key + "_other_" + g;
    propperKeyNoG = w === "self" ? key + "_self" : key + "_other";
    return result.replace(
      key,
      flatT(propperKey) || flatT(propperKeyNoG) || "[" + propperKey + "]"
    );
  }, str);
}
export function t(key) {
  // return allStrings[storeInstance.state.i18n.lang][key]|| '['+key+']'
  // lo anterior no funciona pq el string buit es un falsy
  const texts =
    allStrings[storeInstance.state.i18n.lang] ?? allStrings[fallback];
  let aux = replaceArticles(texts[key] ?? allStrings[fallback][key]);
  return aux != undefined ? aux : "[" + key + "]";
}
/**
 *
 * @param {string} key
 * @param {(str:string)=>string} setStringCallback
 */
export function tRecursive(key, setStringCallback = (s) => s) {
  const str = flatT(key);
  if (!str) return `[${key}]`;
  const keys = str.match(/\$[a-zA-Z_]*/g);
  if (keys)
    return keys.reduce(
      (result, key) =>
        result.replace(
          key,
          setStringCallback(tRecursive(key.slice(1)) || "[" + key + "]")
        ),
      str
    );
  return str;
}
export default {
  methods: {
    t,
    tRecursive,
  },
};
